declare global {
 interface Window {
  dataLayer: unknown[];
  gtag: (...args: unknown[]) => void;
 }
}
export const pageview = (url: string) => window.gtag?.('config','G-K3T0K94HZ3',{page_path:url});
export const event = ({ action, params }: { action:string; params:Record<string,unknown> }) => window.gtag?.('event',action,params);
